export default __webpack_public_path__ + "static/media/june2023-1.dc45bbb1.jpg";